<script setup lang="ts">
import { Checkbox } from 'catalyst-vue'

/**
 * 作品的選取控制項。書架卡片與列表列共用同一個元件，因此兩種呈現的選取語意、
 * 可及名稱與樣式不會分岔。
 */
/** indeterminate 給集合格：成員只選了一部分時顯示半選，點擊後全部加入。 */
defineProps<{ selected: boolean; title: string; indeterminate?: boolean }>()
const emit = defineEmits<{ toggle: [extend: boolean] }>()

/**
 * shift 點擊要連選一整段，因此需要事件本身。Checkbox 的 update:model-value 只給
 * 新的勾選狀態，所以在捕捉階段先記下 shift 有沒有按著，再在 update 時一起送出。
 */
let extend = false
function remember(event: MouseEvent | KeyboardEvent) { extend = event.shiftKey }
</script>

<template>
  <span class="comic-select-box">
    <Checkbox
      color="primary"
      :aria-label="`選取 ${title}`"
      :model-value="selected"
      :indeterminate="indeterminate"
      @click="remember"
      @keydown="remember"
      @update:model-value="emit('toggle', extend)"
    />
  </span>
</template>
